// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Yz3kZ","rootMobile":"styles_rootMobile__3S7B5"};